import React from "react";
import { Col, Row, Tooltip } from "antd";
import { FacebookOutlined, TwitterOutlined } from "@ant-design/icons";
import logo_footer from "../images/design/logoFooter.svg";
import { colors } from "../constants/colors";
import "./contentTwo.scss";
const Footer = () => {
  return (
    <Row
      className="footer"
      style={{
        backgroundColor: colors.gencBlue,
        width: "100%",
        padding: "10vh 0px",
        paddingBottom: "5vh",
      }}
    >
      <Col
        xs={{ span: 8 }}
        sm={{ span: 8 }}
        md={{ span: 8 }}
        lg={{ span: 8 }}
        xl={{ span: 8 }}
        xxl={{ span: 8 }}
        style={{
          margin: 0,
          textAlign: "center",

          paddingRight: "15px",
        }}
      >
        <Tooltip
          placement="topLeft"
          title="GenC Health helps members to consolidate, generate, and store essential health data securely then connect to useful apps and AIs."
          arrowPointAtCenter
        >
          <img alt="img" src={logo_footer} style={{ width: "65%" }} />
        </Tooltip>
      </Col>
      <Col
        xs={{ span: 4 }}
        sm={{ span: 4 }}
        md={{ span: 4 }}
        lg={{ span: 4 }}
        xl={{ span: 4 }}
        xxl={{ span: 4 }}
        // style={{ margin: 0, color: colors.gencWhite }}
        className="footer-details"
      >
        <h4>Platform</h4>
        <p>
          <a href="#ForDoctorID">GenC Health-Box</a>
        </p>
        <p>
          <a href="#WelcometoGenCID">AM Health Store</a>
        </p>
      </Col>
      <Col
        xs={{ span: 4 }}
        sm={{ span: 4 }}
        md={{ span: 4 }}
        lg={{ span: 4 }}
        xl={{ span: 4 }}
        xxl={{ span: 4 }}
        className="footer-details"
      >
        <h4>Subscribe</h4>
        <p>
          <a href="#AboutUsID">Product updates</a>
        </p>
        <p>
          <a href="#WhileTravelingID">Company updates</a>
        </p>
        <p>
          <a href="#BeforTravelingID">Trainings and jobs</a>
        </p>
      </Col>
      <Col
        xs={{ span: 8 }}
        sm={{ span: 8 }}
        md={{ span: 8 }}
        lg={{ span: 8 }}
        xl={{ span: 8 }}
        xxl={{ span: 8 }}
        className="footer-details"
      >
        <h4>Follow us</h4>
        <p>
          <a href="#BeforTravelingID">GenC daily snacks</a>
        </p>
        <div>
          <a
            href="https://www.facebook.com/genchealth/"
            tarGet="_blank"
            title="Facebook"
            className="facebook-icon"
          >
            <FacebookOutlined />
          </a>
          &nbsp;&nbsp;
          <a
            href="https://twitter.com/GenCLabs"
            tarGet="_blank"
            title="Twitter"
            className="twitter-icon"
          >
            <TwitterOutlined />
          </a>
        </div>
      </Col>
      {/* <Row
        style={{
          width: "100%",
          justifyContent: "center",
          color: "#fff",
          fontSize: 15,
          padding: 20,
          borderTop: "2px solid #a9a6a6",
        }}
      >
        <span>
          <p style={{ width: "100%" }}>
            <a
              href="#BeforTravelingID"
              style={{ fontSize: 16, marginRight: "10px" }}
            >
              Privacy policy{" "}
            </a>
          </p>
        </span>
        <span> © Copyright 2020 GenC Labs, Inc. All rights reserved</span>
      </Row> */}
    </Row>
  );
};
export default Footer;
